var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialogos-app',{attrs:{"dialogos":_vm.dialogos}}),_c('svg-component'),_c('audio-player',{ref:"audioPlayer",attrs:{"autoplay":true,"audios":[
  'Modulo 2/AUDIO 06'
  ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }